import { alpha, Container, LinearProgress } from "@mui/material";
import { gridClasses } from "@mui/x-data-grid";

const useStyles = (theme) => ({
  paperModal: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "500px",
    minWidth: "265px",
    width: "85%",
    maxHeight: "95vh",
    padding: "13px 16px 16px 16px",
    borderRadius: "5px",
    position: "relative",
    overflow: "hidden",
    minHeight: "345px",
    height: "auto",
  },
  lineStack: {
    flexWrap: "wrap",
    width: "100%",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",

    //flexWrap: "wrap",
  },
  cardStack: {
    flexDirection: "column",

    alignItems: "start",
    justifyContent: "start",
    wordBreak: "break-all",
    overflowWrap: "break-word",
  },
  cardUserSubTitle: {
    fontSize: "0.875rem",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "3px",
  },
  cardUserSubTitleIcon: {
    fontSize: "18px",
    color: theme.palette.easyLog.tertiary,
  },
  cardText: {
    color: theme.palette.text.shadow,
    fontSize: "14px",
    overflow: "hidden",
    wordBreak: "break-all",
    overflowWrap: "break-word",
    marginLeft: "20px",
  },
  portaBNGTexto: {
    color: theme.palette.text.shadow,
    marginLeft: "20px",
    fontSize: "14px",
    wordBreak: "break-all",
    minHeight: "41px",
  },
  stackErro: {
    width: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "center",
    flex: 1,
    gap: "10px",
  },
  stackErroIcon: {
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    gap: "10px",
  },
  boxBorder: {
    border: "1px solid #2e2e2e",
    width: "100%",
    padding: "16px",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
});
export default useStyles;
